// extracted by mini-css-extract-plugin
export default {"wrapper":"HintChip_wrapper__1efs9","chip":"HintChip_chip__xq0rI","dot":"HintChip_dot__fpHoF"};